import Vue from 'vue';
import Router from 'vue-router'
import NotFound from '../views/NotFound.vue'
import Bypass from '../views/Bypass.vue'
import Consent from '../views/Consent.vue'
import Authorization from '../views/Authorization.vue'
import MobileAuthorizationCheck from '../views/MobileAuthorizationCheck.vue'
import Canceled from '../views/Canceled.vue'
import Expired from '../views/Expired.vue'
import Reuse from '../views/Reuse.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'xID',
      beforeEnter() {
        window.location = "https://x-id.me/"
      }
    },
    {
      path: '/authentication/',
      name: 'authorization',
      component: Authorization
    },
    {
      path: '/mobileAuthorizationCheck/',
      name: 'mobileAuthorizationCheck',
      component: MobileAuthorizationCheck
    },
    {
      path: '/c01ed32d89994f85bc791c06958c3683',
      name: 'bypass',
      component: Bypass
    },
    {
      path: '/consent',
      name: 'consent',
      component: Consent
    },
    {
      path: '/reuse',
      name: 'reuse',
      component: Reuse,
    },
    {
      path: '/canceled',
      name: 'canceled',
      component: Canceled,
      props: route => ({
        redirectURL: route.query.redirectURL || ''
      })
    },
    {
      path: '/expired',
      name: 'expired',
      component: Expired,
      props: route => ({
        redirectURL: route.query.redirectURL || ''
      })
    },
    {
      path: '/:catchAll(.*)',
      name: 'notFound',
      component: NotFound
    },
  ]
})